import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useGetAllCompanies } from "../../utils/queryUtils";
import { setSelectedCompany } from "../../store/action/selected";
import { getIdFromToken } from "../../utils/jwtUtils";

const { Content } = Layout;

export default function LayoutAlt({ children, userChange }) {
  // const [isCompany, setisCompany] = useState(false);
  const dispatch = useDispatch();
  let { _id } = useSelector((st) => st.user);
  const { data: companies } = useGetAllCompanies(_id);
  const user = useSelector(st => st.user)
  let { company: selectedCompany } = useSelector((st) => st.selected);
  const [userId, setUserID] = useState();
  let navigate = useNavigate();
  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const id = await getIdFromToken();
        setUserID(id);
      } catch (error) {

        console.error("Error fetching user ID:", error);
      }
    };
    fetchUserId();
  }, [navigate, user]);
  useEffect(() => {
    if (!user || !userId || !Object.keys(user).length || user.role === '') {
      return;
    }
    if (user.role !== "ADMIN" && user?.company?.length && user?.company[0]?.name) {
      navigate(`/${user?.company[0]?.name}`);
      return
    }
    if (selectedCompany && _id) {
      dispatch(setSelectedCompany(selectedCompany));
      navigate(`/${selectedCompany?.name}`);
    }
    else if ((companies && companies.length > 0 && _id)) {
      if (!selectedCompany) {
        dispatch(setSelectedCompany(companies[0]));
        navigate(`/${companies[0].name}`);
      }
    }
  }, [companies, dispatch, selectedCompany, _id, userId, userChange]);

  return (
    <>
      <Layout
        style={{ minHeight: "90vh" }}
        className="layout-default layout-signin "
      >
        {/* <Header>
          <div className="header-col header-brand">
            <h5>{process.env.REACT_APP_NAME}</h5>
          </div>
          <div className="header-col header-nav">
            <Menu mode="horizontal" defaultSelectedKeys={["1"]}>
              <Menu.Item key="4">
                <Link to="/auth/sign-in">
                  <LoginOutlined />
                  <span> Sign In</span>
                </Link>
              </Menu.Item>
            </Menu>
          </div>
        </Header> */}
        <Content className="signin">{children}</Content>
      </Layout>
    </>
  );
};
